import Keycloak from 'keycloak-js'
import environment from '../../../config'
import { KeycloakInstances, KeycloakRealm } from '../types'

const createInstance = (realm: KeycloakRealm): Keycloak =>
  new Keycloak({
    url: environment.auth.keycloak.url,
    clientId: environment.auth.keycloak.clientId,
    realm,
  })

const instances: KeycloakInstances = {
  active: null,
  options: {
    Ambev: createInstance('Ambev'),
    Third: createInstance('Third'),
  },
}

export default instances
